import React from "react";
import style from "./index.module.scss";
import { Link } from "react-router-dom";
import { HaveWeekTime, TeacherCourse } from "../../../../../service/course";
import { courseDetailUrlNoWeekId } from "../../../../../service/url";
import { CourseItem as CourseItemProps } from "../../../../../service/service";

interface IProps {
    className?: string;
    data: TeacherCourse;
    imgUrl: string;
}

function UnplannedCourseItem({ className, data, imgUrl }: IProps) {
    const { courseName, courseNo, courseSeq, batchNo } = data;

    const linkUrl = `/course/detail/${HaveWeekTime.no}/${batchNo}/${courseNo}/${courseSeq}`;

    return (
        <div className={`${style.root} ${className}`}>
            <div className={style.main}>
                <Link to={linkUrl}>
                    <img className={style.img} src={imgUrl} alt="" />
                    {/*<img*/}
                    {/*    className={style.unplanned}*/}
                    {/*    src={unplannedCourse}*/}
                    {/*    alt=""*/}
                    {/*/>*/}
                    <div className={style.title}>{courseName}</div>
                </Link>
                <div className={style.info}>
                    <span>课程号 {courseNo}</span>
                    <span>编号 {courseSeq}</span>
                </div>
                <div className={style.line} />
                <div className={`${style.itemWrapper}`}>
                    <div className={style.item}>
                        <Link
                            to={`/classes/0/${batchNo}/${courseNo}/${courseSeq}/class`}>
                            <img src={require("./images/icon.png")} alt="" />
                            <span>学员</span>
                        </Link>
                    </div>
                    <div className={style.item}>
                        <Link
                            to={`/course/${batchNo}/${courseNo}/${courseSeq}/score`}>
                            <img src={require("./images/icon2.png")} alt="" />
                            <span>成绩</span>
                        </Link>
                    </div>
                    <div className={style.item}>
                        <Link
                            to={courseDetailUrlNoWeekId(
                                {
                                    courseNo,
                                    courseSeq,
                                    batchNo,
                                    weekTimeId: 0
                                } as CourseItemProps,
                                "/courseChapters"
                            )}>
                            <img src={require("./images/icon6.png")} alt="" />
                            <span>章节</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UnplannedCourseItem;
